export default "__VITE_ASSET__c93aa0a9__"